<template>
  <div class="personal-center">
    <Head /> <Kefu />
    <!-- 顶部用户信息卡片 -->
    <div class="user-card" style="margin-top: 80px">
      <div class="user-name">
        <span class="first-name">{{ info.nickname || '--' }}</span>
        <span class="last-name">{{ info.surname || '--' }}</span>
      </div>
      <div class="user-id">DNI {{ info.username || '--' }}</div>
    </div>

    <!-- 信息展示列表 -->
    <div class="info-list">
      <van-cell title="Area code" :value="info.areaCode" />
      <van-cell title="Number" :value="info.phone" />
      <van-cell title="Email" :value="info.email" />
      <van-cell title="Bank Card" :value="info.bankName + '(' + info.bankNumber + ')'" />
    </div>

    <!-- 功能入口 -->
    <div class="function-section">
      <van-cell title="Loan Agreement" is-link url="/Policy" />
      <van-cell title="Change Password" is-link url="/Forget" />
      <van-cell title="Exit" is-link @click="tuichu()" />
    </div>
  </div>
</template>

<script>
import { Cell, CellGroup, Button, Dialog } from 'vant'
import Store from '@/store'
export default {
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Dialog.name]: Dialog
  },
  data() {
    return {
      info: {}
    }
  },
  async created() {
    const res = await this.$request.getInfo({ username: Store.state.user.userInfo })
    if (res.retCode === '000') {
      this.info = res.result
    } else {
      this.$toast.fail('The account does not exist')
    }
  },
  methods: {
    tuichu() {
      Store.commit('SET_USERINFO', undefined)
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.personal-center {
  padding: 16px;
  background-color: #f7f8fa;
  min-height: 100vh;
}

.user-card {
  background: linear-gradient(135deg, #7832b0, #7832b0);
  color: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.user-name {
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
}

.first-name {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 4px;
}

.last-name {
  font-size: 18px;
  font-weight: 500;
}

.user-id {
  font-size: 14px;
  opacity: 0.9;
}

.info-list {
  margin-bottom: 24px;
  border-radius: 8px;
  overflow: hidden;
}

.section-title {
  padding: 12px 16px;
  font-size: 14px;
  color: #969799;
}

.function-section {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 16px;
}

.logout-btn {
  padding: 0 16px;
}

.van-cell {
  align-items: center;
}

.van-cell__title {
  color: #323233;
}

.van-cell__value {
  color: #969799;
}
</style>
